class ProductInfo extends HTMLElement {
  constructor() {
    super();

    this.sizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        this.calculateHeight();
      })
    })
    this.sizeObserver.observe(this)
  }

  calculateHeight(ev) {
    requestAnimationFrame(() => {
      let rect = this.getBoundingClientRect();

      this.style.setProperty("--dh", rect.height + "px");
    })
  }
}

customElements.define('product-info', ProductInfo);